<template>
    <div class="w-full h-full relative">
        <Header :title="'Mein Profil'" />
        <content-container class="bg-white">
            <profile-form
                :user="GET_USER"
                @change="(user) => UPDATE_USER(user)"
            />
        </content-container>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import { getData } from "../../common/dataHelper";
import ContentContainer from "../../components/layout/ContentContainer.vue";
import Header from "../../components/layout/Header.vue";
import {
    AUTH_USER_TYPES,
    HELPER_TYPES,
    MEDIA_TYPES,
    STORE_TYPES,
} from "../../store/types";
import ProfileForm from "./ProfileForm.vue";

export default defineComponent({
    name: "Profile",
    components: { Header, ContentContainer, ProfileForm },
    setup() {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({});

        /**
         *  Functions
         */
        async function UPDATE_USER(user) {
            let hasNewAvatar = false;
            let newAvatar = null;
            if (user.avatar && !user.avatar.id) {
                hasNewAvatar = true;
                newAvatar = user.avatar;
            }
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "save-button"
            );
            const response = await store.dispatch(
                `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.UPDATE_USER}`,
                { user }
            );
            if (getData(response, "status") == 200) {
                if (hasNewAvatar) {
                    await store.dispatch(
                        `${STORE_TYPES.MEDIA}/${MEDIA_TYPES.UPLOAD_AVATAR}`,
                        { avatar: newAvatar }
                    );
                }
            }
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "save-button"
            );
        }
        /**
         *  Computed
         */
        const GET_USER = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.GET_USER}`
                ]
        );

        /**
         *  Created
         */

        return { state, GET_USER, UPDATE_USER };
    },
});
</script>
